// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__BmSdz","formContainer":"Auth_formContainer__mKRcY","buttonContainer":"Auth_buttonContainer__NkshR","forgotPassword":"Auth_forgotPassword__l43yE"};